import React, { useEffect } from "react";
import { createContext, useState } from "react";
import { loadCartFromLocalStorage, saveCartToLocalStorage } from "../helpers";

const StoreContext = createContext(null);

export type CartItem = {
    id: number,
    name: string,
    barcode: string,
    quantity: any,
    productId: any,
    price: any,
    discountedPrice: any
}

type Cart = CartItem[]


export function StoreProvider({ children }) {

    const [cart, setCart] = useState<CartItem[]>([]);


    const updateCartQuantity = (product, amount = 1) => {
       
        setCart(prevCart => {
            const cartCopy = [...prevCart];
            const index = cartCopy.findIndex(cartItem => cartItem.productId === product.productId);
            
            if (index !== -1) {
                // If item exists, update the quantity
                cartCopy[index].quantity = amount;
    
                // Optional: Remove the item if quantity drops to 0 or less
                if (cartCopy[index].quantity <= 0) {
                    cartCopy.splice(index, 1);
                }
            } else {
                // If item doesn't exist, add it with a quantity of 1
                cartCopy.push({ ...product, quantity: amount });
            }
    
            return cartCopy;
        });
    };
    

    const setItemQuantity = (product, amount)=>{
        setCart(prevCart => {
            const cartCopy = [...prevCart];
            const index = cartCopy.findIndex(cartItem => cartItem.productId === product.productId);
            
            if (index !== -1) {
                // If item exists, update the quantity
                cartCopy[index].quantity = amount;
            } 
    
            return cartCopy;
        });
    }
 

    const addToCart = (product: CartItem, amount:number) => {
      
        
        updateCartQuantity(product, amount);
    };
    
    const decreaseQuantity = (product: CartItem) => {
      
        
        updateCartQuantity(product, -1);
    };
    

    
    
    const removeFromCart = (productId: number) => {
        setCart(prevCart => {
            const updatedCart = prevCart.filter(product => product.productId !== productId);
            // saveCartToLocalStorage(updatedCart); // Uncomment if needed
            return updatedCart;
        });
    };
    
    const emptyCart = () => {
        setCart([]);
        // saveCartToLocalStorage([]);
    };

   

    useEffect(()=>{
        console.log("cart changed", cart)
    }, [cart])


 
    let params = {
        cart,
        addToCart,
        removeFromCart,
        emptyCart,
        decreaseQuantity,
        setItemQuantity
    }
    return (
        <StoreContext.Provider value={params}>
            {children}
        </StoreContext.Provider>
    );
}

export default StoreContext;